import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';

export const getSingleSliderFunc = createAsyncThunk(
  "getSingleSlider",
  async (id, thunkAPI) => {
    try {
      const response = await api.get(`dashboard/general-settings/sliders/${id}`);
      return response.data.data.slider;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const getSingleSliderSlicer = createSlice({
  name: "getSingleSlider",
  initialState: {
    loading: false,
    data: null,
    error: null,
    apiErrors: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSingleSliderFunc.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.apiErrors = {};
      })
      .addCase(getSingleSliderFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getSingleSliderFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.apiErrors = action.payload?.errors || {};
      });
  },
});

export default getSingleSliderSlicer.reducer;
